export enum EtatPageEnum {
    PageBlanche,
    PagePreteAffichage,
    Cadenas,
    Spinner
}
